module.exports = __webpack_public_path__ + "static/img/23c.973b44c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/23c.jpg
// module id = Y14R
// module chunks = 0